<div *ngIf="isLoading || isSubmitting">
    <mat-progress-spinner mode="indeterminate" diameter="50"></mat-progress-spinner>
</div>

<form [formGroup]="bulkTransferForm" (ngSubmit)="onSubmit()">

    <div *ngIf="canAddRows" class="add-row-section">
        <button mat-raised-button type="button" color="primary" (click)="addScheduleOrderRow()"
            [disabled]="isLoading || isSubmitting">
            <mat-icon>add</mat-icon> Add Order Row
        </button>
        <span class="add-row-hint">(Manually add orders to process)</span>
    </div>

    <div class="bulk-actions-section" *ngIf="selection.hasValue()">
        <p>Bulk Actions</p>
        <button mat-stroked-button color="primary" type="button" (click)="openBulkPlaceDialog()">
            Choose place
        </button>
        <button mat-stroked-button color="primary" type="button" (click)="openBulkStatusDialog()">
            Choose status
        </button>
    </div>

    <div formArrayName="scheduleOrders" class="table-container">
        <table mat-table [dataSource]="dataSource" class="schedule-table">

            <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef>
                    <mat-checkbox color="primary" (change)="$event ? toggleAllRows() : null"
                        [checked]="selection.hasValue() && isAllSelected()"
                        [indeterminate]="selection.hasValue() && !isAllSelected()">
                    </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let element">
                    <mat-checkbox color="primary" (click)="$event.stopPropagation()"
                        (change)="$event ? selection.toggle(element) : null" [checked]="selection.isSelected(element)">
                    </mat-checkbox>
                </td>
            </ng-container>

            <ng-container matColumnDef="rowStatus">
                <th mat-header-cell *matHeaderCellDef> Status </th>
                <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i">
                    <div class="status-indicator">
                        <mat-progress-spinner *ngIf="getFormControl(element, 'isProcessing')?.value"
                            mode="indeterminate" diameter="20" class="status-spinner" matTooltip="Processing..."
                            matTooltipPosition="above">
                        </mat-progress-spinner>
                        <mat-icon
                            *ngIf="!getFormControl(element, 'isPlaceholder')?.value && getFormControl(element, 'isSuccess')?.value && !getFormControl(element, 'isProcessing')?.value"
                            color="primary" class="status-icon" matTooltip="Successfully updated"
                            matTooltipPosition="above">check_circle</mat-icon>
                        <mat-icon
                            *ngIf="getFormControl(element, 'errorMessage')?.value && !getFormControl(element, 'isProcessing')?.value"
                            color="warn" class="status-icon"
                            [matTooltip]="getFormControl(element, 'errorMessage')?.value || 'Error'"
                            matTooltipPosition="above">error</mat-icon>
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="orderRef">
                <th mat-header-cell *matHeaderCellDef> Order Ref # / Identify </th>
                <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i">
                    <div *ngIf="getFormControl(element, 'isPlaceholder')?.value" class="identify-order-container">
                        <div class="identify-buttons">
                            <button mat-stroked-button color="primary" type="button" class="identify-action-button"
                                (click)="openOrderSearchDialog(i)"
                                [disabled]="isSubmitting || getFormControl(element, 'isProcessing')?.value">
                                <mat-icon>manage_search</mat-icon> Enter Ref
                            </button>
                            <button mat-stroked-button color="primary" type="button" class="identify-action-button"
                                (click)="openOrderScanDialog(i)"
                                [disabled]="isSubmitting || getFormControl(element, 'isProcessing')?.value">
                                <mat-icon>qr_code_scanner</mat-icon> Scan Order
                            </button>
                        </div>
                        <mat-error
                            *ngIf="getFormControl(element, 'errorMessage')?.value && !getFormControl(element, 'isProcessing')?.value"
                            class="identify-error">
                            {{ getFormControl(element, 'errorMessage')?.value }}
                        </mat-error>
                    </div>

                    <span *ngIf="!getFormControl(element, 'isPlaceholder')?.value">
                        {{ getFormControl(element, 'orderRef')?.value || 'N/A' }}
                    </span>
                </td>
            </ng-container>

            <ng-container matColumnDef="animalName">
                <th mat-header-cell *matHeaderCellDef> Animal Name </th>
                <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i">
                    <span *ngIf="!getFormControl(element, 'isPlaceholder')?.value">
                        {{ getFormControl(element, 'animalName')?.value || 'N/A' }}
                    </span>
                    <span *ngIf="getFormControl(element, 'isPlaceholder')?.value" class="placeholder-text">-</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="newSchedulingStatus">
                <th mat-header-cell *matHeaderCellDef> New Scheduling Status </th>
                <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i">

                    <ng-container *ngIf="!getFormControl(element, 'isPlaceholder')?.value">
                        <mat-form-field appearance="outline" class="compact-form-field">
                            <mat-label>Set Schedule Status</mat-label>
                            <mat-select formControlName="newSchedulingStatus" required>
                                <mat-option *ngFor="let schedStatus of validSchedulingStatuses" [value]="schedStatus">
                                    {{ schedStatus }}
                                </mat-option>
                            </mat-select>
                            <mat-error
                                *ngIf="getFormControl(element, 'newSchedulingStatus')?.hasError('required') && getFormControl(element, 'newSchedulingStatus')?.touched">
                                Scheduling status required.
                            </mat-error>
                        </mat-form-field>
                    </ng-container>

                    <span *ngIf="getFormControl(element, 'isPlaceholder')?.value" class="placeholder-text">-</span>
                </td>
            </ng-container>
            <ng-container matColumnDef="processingPlace">
                <th mat-header-cell *matHeaderCellDef> Processing Place </th>
                <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i">

                    <ng-container *ngIf="!getFormControl(element, 'isPlaceholder')?.value">
                        <div *ngIf="getFormControl(element, 'placeId')?.value as placeIdValue"
                            class="place-display-container">
                            <app-display-place-field [placeId]="placeIdValue"></app-display-place-field>
                            <button mat-icon-button color="warn" type="button" class="clear-place-button"
                                (click)="clearPlace(i)"
                                [disabled]="isSubmitting || getFormControl(element, 'isProcessing')?.value"
                                matTooltip="Clear selected place" aria-label="Clear selected place">
                                <mat-icon>close</mat-icon>
                            </button>
                        </div>

                        <div *ngIf="!getFormControl(element, 'placeId')?.value" class="place-selection-container">
                            <div class="place-buttons">
                                <button mat-stroked-button color="primary" type="button" class="place-action-button"
                                    (click)="openPlaceSearchDialog(i)"
                                    [disabled]="isSubmitting || getFormControl(element, 'isProcessing')?.value">
                                    <mat-icon>search</mat-icon> Select Place
                                </button>
                                <button mat-stroked-button color="accent" type="button" class="place-action-button"
                                    (click)="openPlaceScanDialog(i)"
                                    [disabled]="isSubmitting || getFormControl(element, 'isProcessing')?.value">
                                    <mat-icon>qr_code_scanner</mat-icon> Scan Place
                                </button>
                            </div>
                            <mat-error
                                *ngIf="getFormControl(element, 'placeId')?.hasError('required') && getFormControl(element, 'placeId')?.touched"
                                class="place-error">
                                Place required.
                            </mat-error>
                        </div>
                    </ng-container>

                    <span *ngIf="getFormControl(element, 'isPlaceholder')?.value" class="placeholder-text">-</span>

                </td>
            </ng-container>

            <ng-container matColumnDef="newOrderStatus">
                <th mat-header-cell *matHeaderCellDef> New Order Status </th>
                <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i">
                    <ng-container *ngIf="!getFormControl(element, 'isPlaceholder')?.value">
                        <mat-form-field appearance="outline" class="compact-form-field">
                            <mat-label>Change Status To</mat-label> <mat-select formControlName="newOrderStatus"
                                required>
                                <mat-option
                                    *ngFor="let status of allOrderStatuses | filterStatuses : getFormControl(element, 'validStatusTransitions')?.value"
                                    [value]="status.id"> {{ status.name }} </mat-option>
                                <mat-option
                                    *ngIf="(allOrderStatuses | filterStatuses : getFormControl(element, 'validStatusTransitions')?.value)?.length === 0"
                                    [disabled]="true">
                                    No further statuses available
                                </mat-option>
                            </mat-select>
                            <mat-error
                                *ngIf="getFormControl(element, 'newOrderStatus')?.hasError('required') && getFormControl(element, 'newOrderStatus')?.touched">
                                Status required.
                            </mat-error>
                        </mat-form-field>
                    </ng-container>
                    <span *ngIf="getFormControl(element, 'isPlaceholder')?.value" class="placeholder-text">-</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef> Actions </th>
                <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i">
                    <button mat-icon-button color="warn" type="button" (click)="removeScheduleOrderRow(i)"
                        [disabled]="isSubmitting || (!getFormControl(element, 'isPlaceholder')?.value && (getFormControl(element, 'isProcessing')?.value || getFormControl(element, 'isSuccess')?.value))"
                        aria-label="Remove row" matTooltip="Remove this row" matTooltipPosition="above">
                        <mat-icon>delete_outline</mat-icon>
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>

            <tr mat-row *matRowDef="let row; let i = index; columns: displayedColumns;" [formGroupName]="i"
                [class.row-placeholder]="getFormControl(row, 'isPlaceholder')?.value"
                [class.row-processing]="getFormControl(row, 'isProcessing')?.value"
                [class.row-success]="!getFormControl(row, 'isPlaceholder')?.value && getFormControl(row, 'isSuccess')?.value"
                [class.row-error]="getFormControl(row, 'errorMessage')?.value && !getFormControl(row, 'isProcessing')?.value">
            </tr>

            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell no-data-cell" [attr.colspan]="displayedColumns.length">
                    {{ isLoading ? 'Loading initial data...' : 'No schedule orders added yet. Click "Add Order Row".' }}
                </td>
            </tr>

        </table>
    </div>
    <div class="submit-section">
        <button mat-raised-button color="primary" type="submit"
            [disabled]="isLoading || isSubmitting || !bulkTransferForm.valid || scheduleOrdersFormArray.length === 0">
            <span *ngIf="!isSubmitting">Process Identified Transfers</span> <span
                *ngIf="isSubmitting">Processing...</span>
        </button>
        <div *ngIf="bulkTransferForm.invalid && bulkTransferForm.touched && !isSubmitting" class="error-summary">
            Please correct errors or identify/remove placeholder rows before processing. </div>
    </div>

</form>